import { useMutation } from "@tanstack/react-query";
import AIToolsAPI from "../../../api/api/AIToolsAPI";

interface MutationProps {
  fileURL: string;
  language: string;
  onSuccess: (file: any) => void;
  onError: () => void;
}

export default function useTranslatePdf() {
  const translatePdf = useMutation({
    mutationFn: ({ fileURL, language }: MutationProps) => {
      return AIToolsAPI.translatePdf(fileURL, language);
    },
    onSuccess: (pdfUrl, { onSuccess }) => {
      if (!pdfUrl) return;

      onSuccess && onSuccess(pdfUrl);
    },
    onError: (_, { onError }) => {
      onError && onError();
    },
  });

  return {
    translatePdf: translatePdf.mutate,
    translatingPdf: translatePdf.isPending,
  };
}
